module.exports = __webpack_public_path__ + "static/media/jobs.1b4bfbb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs.jpg
// module id = 193
// module chunks = 0